// extracted by mini-css-extract-plugin
module.exports = {"container":"Zw-z","recos":"_w-z","productCardOverride":"ax-z"};